import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 155.64 155.64">
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            fill="#15a2b2"
            fillRule="evenodd"
            d="M77.82 34.42a43.41 43.41 0 11-43.41 43.4 43.42 43.42 0 0143.41-43.4z"
            data-name="Path 1869"
          />
          <g data-name="Group 1112">
            <path
              fill="#138594"
              d="M46.26 48c1.79.59 2 1.25 3.26 2.68 2.68 3-1 3.69-3.82 6.52a17.25 17.25 0 00-4 5.32c-1.79 3.33 1.1 6.59 2.68 9s2.89 4.34 2.54 7c-.31 2.45 2 12.74 3 17.85.28 1.37.89 9.86 4.66 8.12 4.06-2.58 5.68-7.57 6.78-9.58 5.09-9.47 6.36-14.09 18.2-18C85.18 75 86 69.16 83 64.22a16.24 16.24 0 00-5.37-5.56c-8.07-4.66-10.38-6.26-8.88-9.35 2.15-4 7 .42 14.78-4.2 2.39-.62 4.72-5.26 7.56-8.6a39.78 39.78 0 00-13.25-2.06C70.4 34.42 55.13 38.74 46.26 48zm63.1 59.6c.32-.2 1.14-1.63 1.49-1.66a41 41 0 004.5-6.84 43.6 43.6 0 005.87-21.46c0-13.47-7.79-27.76-18.28-35.24 1.25 5-5.53 12.5-.37 15.29 2.3 1.17 4.19 2.13 3.45 5s-3 1.07-6.15 2.08c-3.79 1.19-6.59 4-6.46 8.45a21.33 21.33 0 002.8 8.14 14.29 14.29 0 001.79 2.3c8.76 9.36 1.91 12.46-4.6 18.26-1.65 1.48-9.53 12.61-5.69 13a30.93 30.93 0 007.13-.26c3.49-.74 10.22-4.45 14.53-7.07zm-23.23 12.8a42.17 42.17 0 01-8.31.8c-5.87.08-22.36-4.35-29.9-12 5 .76 12.87.81 18.32 2.8s9.69 5.18 19.89 8.35z"
              data-name="Path 1870"
              opacity="0.2"
            />
          </g>
          <path
            fill="#69f34f"
            d="M109.86 106.3a2.2 2.2 0 011-.33A43.38 43.38 0 00106 44.82l-.58-.48-.1-.08a14.82 14.82 0 01-1 8.24 5.76 5.76 0 00-.41 1.34c-.34 2 1.55 3 3 3.73 2.32 1.18 4.18 2.13 3.45 5s-3.47 3.61-6.62 4.61c-3.77 1.2-6.11 1.47-6 5.92a13.14 13.14 0 002.08 6.49 15 15 0 001.78 2.34c8.75 9.35 2 15.36-4.49 21.17-.86.76-9.63 8.21-5.11 8.71a18.93 18.93 0 005.36-.47 42.25 42.25 0 0012.48-5zm-28.08 14.75q-2 .18-4 .18a43.2 43.2 0 01-27.57-9.88c5 .76 10.26 1.67 14.17 3.12 6.94 2.52 7.15 3.41 17.35 6.59zm-4-86.63a43.78 43.78 0 019.54 1c-2.83 3.35-6.13 7.18-8.51 7.79-4 1-11.31.74-13.45 4.72-2.36 4.38-.22 5.62 7.85 10.29a16.3 16.3 0 015.37 5.55 12.45 12.45 0 011.82 5.21A5 5 0 0179.19 73a8.54 8.54 0 01-3.52 2.06c-10.21 3.42-10.62 4.36-12.6 9a45.51 45.51 0 01-2.23 4.61c-.72 1.29-1.34 2.47-1.93 3.55a54 54 0 01-3.51 6c-2.69 3.56-4-4.76-4.3-6.12A52.44 52.44 0 0150 78.51c.34-2.65-1-4.73-2.53-7s-3.39-5.1-1.62-8.44A27.53 27.53 0 0151 56.45c2.83-2.82 4.41-4.45 1.74-7.45A10.44 10.44 0 0048 46.32a43.19 43.19 0 0129.85-11.9z"
            data-name="Path 1871"
          />
          <path fill="none" d="M0 0h155.64v155.64H0z" />
        </g>
      </g>
    </svg>
  );
}

export default Icon;
